var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangePerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 25C27.6274 25 33 19.6274 33 13C33 6.37258 27.6274 1 21 1C14.3726 1 9 6.37258 9 13C9 19.6274 14.3726 25 21 25Z",
    stroke: "#EA4E44",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 45.4697C1 35.2697 10 26.0098 21 26.0098C32 26.0098 41 35.2797 41 45.4697V47.0098H1V45.4697Z",
    stroke: "#EA4E44",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePerson);
export default __webpack_public_path__ + "static/media/orangePerson.97d2e703dd960052d632528ed41c6b58.svg";
export { ForwardRef as ReactComponent };